module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "740px",
      "margin": "0 auto",
      "border": "1px solid",
      "box-shadow": "5px 5px 5px #888888"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "640px",
      "margin": "0 auto"
    },
    attrs: {
      "id": "content"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 6pt",
      "orphans": "0",
      "text-align": "right",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("合同编号：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.code))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.name))])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.year))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.month))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.day))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("日")])]), _vm._v(" "), _c('br', {
    staticStyle: {
      "clear": "both",
      "mso-break-type": "section-break",
      "page-break-before": "always"
    }
  }), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt",
      "font-weight": "normal"
    }
  }, [_vm._v("乙方：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.Bname))])]), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("售后服务")]), _vm._v(" "), _vm._m(35), _vm._v(" "), _c('ol', {
    staticClass: "awlist8",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("客户服务")]), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "5pt 0pt 0pt 15pt",
      "text-indent": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.BcontactsName))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "5pt 0pt 0pt 15pt",
      "text-indent": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("职务：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.BcontactsPost))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "5pt 0pt 0pt 15pt",
      "text-indent": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("电话：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.BcontactsTel))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "5pt 0pt 0pt 15pt",
      "text-indent": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("手机：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.BcontactsPhone))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "5pt 0pt 0pt 15pt",
      "text-indent": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("邮箱：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.BcontactsEmail))])])])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("服务费及货款结算")]), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('ol', {
    staticClass: "awlist9",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("除非另有其他书面约定，甲方通过银行转账或电汇方式向乙方下述银行账号付款：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("收款方名称：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.collectName))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("税务登记号：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.taxNum))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("开户银行：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.bankName))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("账号：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.bankNum))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方如需修改付款信息，应提前在对账结束前书面通知甲方。如乙方未能在上述期限内通知甲方，则乙方应承担甲方根据未修改的付款信息向乙方进行付款所发生的一切后果。")])]), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45)])]), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("期限和终止")]), _vm._v(" "), _vm._m(52), _vm._v(" "), _c('ol', {
    staticClass: "awlist16",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议有效期限为自签署之日起至")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.endYear))]), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.endMonth))]), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.endDay))]), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("日")])]), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54)])]), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56)]), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "margin-left": "0pt",
      "width": "464.3pt"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tr', {
    staticStyle: {
      "height": "96.8pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "264pt"
    }
  }, [_vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("签约日期:")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.AsignYear))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.AsignMonth))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.AsignDay))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("日")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "200pt"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方（盖章）：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.Bsign))])]), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _vm._m(68), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("签约日期：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.BsignYear))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.BsignMonth))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.BsignDay))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("日")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "221.35pt"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("授权代表人签字：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.Adeputy))])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "221.35pt"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("授权代表人签字：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contract.Bdeputy))])])])])]), _vm._v(" "), _vm._m(69), _vm._v(" "), _vm._m(70), _vm._v(" "), _vm._m(71), _vm._v(" "), _vm._m(72), _vm._v(" "), _vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _vm._m(75), _vm._v(" "), _vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _vm._m(78), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "margin-left": "0pt",
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(79), _vm._v(" "), _vm._l((_vm.contract.goodsStandard1), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "background-color": "#ffffff",
        "border-bottom-color": "#000000",
        "border-bottom-style": "solid",
        "border-bottom-width": "1pt",
        "border-left-color": "#000000",
        "border-left-style": "solid",
        "border-left-width": "1pt",
        "border-right-color": "#000000",
        "border-right-style": "solid",
        "border-right-width": "1pt",
        "padding-left": "4.9pt",
        "padding-right": "4.9pt",
        "vertical-align": "top",
        "width": "127.45pt"
      }
    }, [_vm._v("\n                    " + _vm._s(item.category) + "\n\n                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffffff",
        "border-bottom-color": "#000000",
        "border-bottom-style": "solid",
        "border-bottom-width": "1pt",
        "border-right-color": "#000000",
        "border-right-style": "solid",
        "border-right-width": "1pt",
        "padding-left": "5.4pt",
        "padding-right": "4.9pt",
        "vertical-align": "top",
        "width": "83.15pt"
      }
    }, [_vm._v("\n                    " + _vm._s(item.brand) + "\n\n                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffffff",
        "border-bottom-color": "#000000",
        "border-bottom-style": "solid",
        "border-bottom-width": "1pt",
        "border-right-color": "#000000",
        "border-right-style": "solid",
        "border-right-width": "1pt",
        "padding-left": "5.4pt",
        "padding-right": "4.9pt",
        "vertical-align": "top",
        "width": "171.8pt"
      }
    }, [_vm._v("\n                    " + _vm._s(item.ratio) + "\n\n                ")])])
  })], 2), _vm._v(" "), _vm._m(80), _vm._v(" "), _vm._m(81), _vm._v(" "), _vm._m(82), _vm._v(" "), _vm._m(83), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "margin-left": "0pt",
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(84), _vm._v(" "), _vm._l((_vm.contract.goodsStandard2), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "background-color": "#ffffff",
        "border-bottom-color": "#000000",
        "border-bottom-style": "solid",
        "border-bottom-width": "1pt",
        "border-left-color": "#000000",
        "border-left-style": "solid",
        "border-left-width": "1pt",
        "border-right-color": "#000000",
        "border-right-style": "solid",
        "border-right-width": "1pt",
        "padding-left": "4.9pt",
        "padding-right": "4.9pt",
        "vertical-align": "top",
        "width": "127.45pt"
      }
    }, [_vm._v("\n                    " + _vm._s(item.category) + "\n\n                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffffff",
        "border-bottom-color": "#000000",
        "border-bottom-style": "solid",
        "border-bottom-width": "1pt",
        "border-right-color": "#000000",
        "border-right-style": "solid",
        "border-right-width": "1pt",
        "padding-left": "5.4pt",
        "padding-right": "4.9pt",
        "vertical-align": "top",
        "width": "127.45pt"
      }
    }, [_vm._v("\n                    " + _vm._s(item.brand) + "\n\n                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffffff",
        "border-bottom-color": "#000000",
        "border-bottom-style": "solid",
        "border-bottom-width": "1pt",
        "border-right-color": "#000000",
        "border-right-style": "solid",
        "border-right-width": "1pt",
        "padding-left": "5.4pt",
        "padding-right": "4.9pt",
        "vertical-align": "top",
        "width": "127.5pt"
      }
    }, [_vm._v("\n                    " + _vm._s(item.ratio) + "\n\n                ")])])
  })], 2), _vm._v(" "), _vm._m(85)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 0px 15px 0px",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.htmlPrint()
      }
    }
  }, [_vm._v("打 印")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.returnWindow()
      }
    }
  }, [_vm._v("返 回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "12pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt",
      "orphans": "0",
      "text-align": "center",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "12pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "24pt",
      "font-weight": "bold"
    }
  }, [_vm._v("服务协议")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "12pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "12pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v("天津果敢时代国际贸易有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "18pt",
      "font-weight": "bold"
    }
  }, [_vm._v("与")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "14pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "12pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "12pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "6pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "12pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "16pt",
      "font-weight": "bold"
    }
  }, [_vm._v("服务协议")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本《服务协议》（以下简称“"), _c('b', [_vm._v("本协议")]), _vm._v("”）由以下双方在北京市朝阳区签署：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt",
      "font-weight": "normal"
    }
  }, [_vm._v("甲方：")]), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("天津果敢时代国际贸易有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方和乙方以下单称为“"), _c('b', [_vm._v("一方")]), _vm._v("”，合称为“"), _c('b', [_vm._v("双方")]), _vm._v("”。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("鉴于：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt 28.35pt",
      "text-align": "justify",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方及其关联公司是“大V店”电子商务平台、移动客户端及其他分销平台（“"), _c('b', [_vm._v("大V店平台")]), _vm._v("”）的所有者和平台服务提供者。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt 28.35pt",
      "text-align": "justify",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "normal"
    }
  }, [_vm._v("B")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方同意按照本协议的约定，在大V店平台上推广销售其商品或服务（包括但不限于发布商品或服务信息、与消费者达成交易、完成商品配送或以约定方式提供服务等）。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("双方经友好协商，达成协议内容如下：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("资质审核")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist1",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方根据大V店平台公示的《大V店平台商家入驻规则》和《招商标准》提交在大V店平台开展经营活动的必要信息和资质文件（具体内容详见")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("附件一《乙方资质证明文件清单》")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("）。甲方仅在乙方符合甲方要求的商品品牌、类目和经营范围内许可乙方使用甲方服务。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方如变更所提交信息和资质文件，或新增商品品牌、类目或服务内容，应即时通知甲方并更新或补充相应信息和有效的资质文件，否则甲方有权拒绝继续提供服务。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方保证其信息和资质文件的真实性和有效性，并确保所提交信息和资质文件在乙方使用大V店平台服务期间均符合甲方不时修订并公示的《大V店平台商家入驻规则》和《招商标准》。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("大V店平台服务")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist2",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("平台技术服务"), _c('br'), _vm._v("甲方为乙方消费者提供交易平台，同时为乙方提供与大V店平台服务相关的技术服务，包括但不限于商品（服务）信息发布、平台内信息检索、订单管理、款项支付等技术服务。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("代收款服务"), _c('br'), _vm._v("乙方同意，消费者在大V店平台购买乙方商品或服务应支付的款项，由乙方委托甲方代为收取。消费者按照大V店平台交易规则将相关款项通过各类支付渠道（包括但不限于网上银行、第三方支付机构等支付方式）支付至甲方收款账户，甲乙双方按照本协议约定进行款项结算。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("其他服务"), _c('br'), _vm._v("甲方有权根据乙方请求自行决定为乙方提供市场营销服务、仓储物流服务、客户服务、金融服务等增项服务，届时双方将另行签署协议或以其他书面方式确认。甲方有权随时对甲方平台的相关服务和功能进行变更、升级和完善，有权定期或不定期对甲方平台进行系统维护、开发新的模块、功能和软件。除非甲方在本协议中另有说明，否则变更后的服务仍应适用于本协议。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("大V店平台规则")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist3",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方使用大V店平台服务，同意遵守甲方制订并在大V店平台公示的《大V店平台商家入驻规则》及其他商家规范（“"), _c('b', [_vm._v("大V店平台规则")]), _vm._v("”），大V店平台规则作为对本协议双方权利义务的补充，构成本协议的一部分。甲方有权根据需要不时制订或修改大V店平台规则，并在大V店平台上更新公示。乙方如不同意相关规则变更，须立即以正式书面方式告知甲方，甲方有权选择是否对乙方适用该规则变更或立即与乙方解约。如乙方继续使用大V店平台服务，视为乙方对大V店平台规则的无条件接受。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("商品销售")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist4",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方通过大V店平台向消费者销售商品或服务。乙方商品或服务应符合国家法律法规规定、大V店平台规则和《招商标准》。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方应将其所销售商品或服务的图片、文字等信息按照甲方要求，上传至大V店平台。乙方自行负责相关信息日常在线的维护，包括但不限于在售商品增减、商品信息调整、商品价格调整、日常客户服务等。乙方的维护内容需要甲方确认后方能在前端呈现。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方通过大V店平台推广销售商品或服务，应严格遵守国家有关产品质量责任、消费者权益保护、广告发布和促销行为等法律法规的相关规定。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("商品交付")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist5",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("消费者在大V店平台提交订单并全额支付订单款项后【48】小时内，乙方负责将消费者购买的有关商品按照订单载明地址信息交付配送商，并通过大V店平台上传发货信息（包括但不限于配送方名称、配送单号信息等）。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方应按甲方要求对商品进行二次包装，在包装中附带甲方要求的材料，包括但不限于发货单、商品发票等，但不得夹带任何未经甲方许可的资料、宣传单等资料。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方在配送过程中产生的包装费用、物流配送费用等均由乙方自行承担。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("商品定价")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist6",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方商品的销售价格由乙方自主决定，但乙方同意，甲方对乙方的价格有审核的权利。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方确认，乙方在大V店平台呈现的商品销售价格应为含税价格，且已包含乙方就该商品销售所提供的配送、售后服务等全部费用。乙方不得在向消费者配送商品或提供其他服务的过程中收取任何其他费用。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("商品质量")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist7",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方向消费者配送的商品（包含赠品）应为其合法生产或有权经销的、符合国家质量标准或行业标准及双方约定的标准的、全新且未曾在其他渠道销售过的商品，该等商品不存在侵犯任何第三方权益的情况。该等商品质量应符合大V店平台规则的相关要求。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("商品质量应符合下列要求：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）商品不存在危及人身、财产安全的危险，符合保障人体健康和人身、财产安全的相关国家、行业标准；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）具备商品应当具备的使用性能，对商品存在使用性能的瑕疵已作出说明；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）符合在商品或者其包装上注明采用的商品标准，与广告、商品说明、实物样品表明的质量状况相符合；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）食品（包括成分及用量）需符合我国食品安全法及相关法律法规的标准和要求；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（5）其他特殊产品质量的国家标准。")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("商品或者商品包装上的标识真实，并符合下列要求：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）有产品质量检验合格证明；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）商品应当按照法律法规的要求贴注条形码及中文标识，有中文标明的产品名称、成分及用量规格、等级、有效期、生产厂厂名和厂址等信息；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）限期使用的商品，在显著位置标明生产日期和安全使用期或失效日期；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）商品成分说明或原料表中对于特殊成分应当予以相应的说明；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（5）使用不当容易造成商品本身损坏或者可能危及人身、财产安全的商品，有警示标志。其他需要事先让消费者知晓的事项，在外包装上标明，或者预先向消费者提供有关资料；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（6）其他关于产品包装标识的国家标准要求。")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方保证不存在以下欺诈行为：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）在商品中掺杂、掺假、以假充真、以次充好或以不合格产品冒充合格产品；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）供应国家明令淘汰的产品或者失效、变质的商品；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）伪造商品的产地，伪造或者冒用他人的厂名、厂址，伪造或者冒用认证标志、名优标志等质量标志；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）依法需强制检验或认证的，未履行检验或认证手续或者伪造检验或认证结果；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（5）配送的商品中出现已拆封的商品或“空盒”商品（含缺少配件、说明书等随机附件）；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（6）乙方向消费者提供有关商品或者服务的信息不真实，存在引人误解的虚假宣传，发布虚假广告或者欺骗、误导消费者，使购买商品或者接受服务的消费者的合法权益受到损害；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（7）其他国家法律法规明文禁止的欺诈行为。")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方提供的所有商品清洁整齐，包装完好，适宜销售，配送时包装不得出现任何污损。凡有保质期的商品如果保质期大于六个月的，乙方商品送达消费者订单指定收货地时其商品保质期距到期日的时限不得少于保质期规定的一半；如果商品保质期小于六个月，乙方商品送达消费者订单指定收货地时则不应少于其保质期的三分之二。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方提供商品不符合国家法律法规相关规定和前述商品质量要求，即视为不合格商品，消费者有权要求退款退货。乙方应当按照大V店平台的退货政策和流程为消费者办理退货。退货过程中产生的运输费用由乙方承担。如因乙方前述行为造成甲方或消费者任何损害（包括人身和财产损失）的，乙方应当承担全部赔偿责任。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("如乙方销售商品或服务存在下述情形的：销售国家禁止流通，限制流通商品；提供非法服务；未经授权销售，销售侵权、假冒伪劣或有其他问题的商品；宣传图片或商品信息等违法侵权；其他甲方认为不宜继续销售的情形，甲方可对该商品进行即时下架处理，并通知乙方提供相关相反证据，包括但不限于合法授权销售证明，乙方应立即提交。若乙方不能提供或经查前述情形属实的，甲方有权采取下列一项或多项措施：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）要求乙方承担大V店平台规则规定的惩罚金；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）要求乙方支付本协议生效到上述行为发生时为止乙方通过甲方销售商品总金额的10%作为违约金；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）要求乙方赔偿甲方因此遭受的全部损失；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）解除本协议。")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("如因乙方提供商品存在瑕疵危及人身财产安全，或因涉及重大安全问题危及甲方名誉受损，或引起或可能引起较大规模投诉、举报或诉讼，甲方有权要求召回有关商品，乙方应按甲方要求在大V店平台或甲方指定其他媒介发布有关商品的召回信息，完成对召回商品的退货、换货、维修，并承担由此产生的所有费用。乙方同时应赔偿因此造成甲方及消费者的任何损失。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方应根据国家法律法规、本协议约定、大V店平台规则及相关政策规定，为消费者提供乙方商品的“退货、换货、维修”等售后服务，包括但不限于：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）如消费者在收到商品前申请取消订单或拒绝签收商品，乙方同意甲方取消该笔订单并退还货款。该笔订单商品由乙方收回，因此产生的一切费用由乙方自行承担；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）如消费者在收到乙方所售商品之日起【15】日内要求无条件退换货的，乙方同意甲方接受退换货申请，并在乙方收到消费者退回商品后办理相应手续，因退换货产生的配送费用甲方应告知申请的消费者自行承担；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）如消费者在收到乙方所售商品后因商品违法、侵权、质量问题等要求退换货，乙方同意甲方接受退换货申请，并在收到消费者退回的商品后办理相应手续，因退换货产生的全部费用由乙方承担；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）如消费者要求维修商品，乙方应在收到消费者退回商品后的【30】日内将破损商品修复至令消费者满意且能合理使用的程度后重新配送给消费者；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（5）如消费者因乙方销售商品违法、侵权、质量问题等投诉、举报或提起诉讼，乙方负责处理解决并承担全部费用，保护甲方免予承担因此而产生的任何法律责任（包括任何赔偿或处罚）或声誉受损。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("先行赔付"), _c('br'), _vm._v("乙方了解并同意，如乙方未适当履行本协议规定的售后服务或未适当处理消费者投诉、举报或诉讼，甲方有权根据国家法律法规、本协议、大V店平台规则及相关政策规定，判断乙方是否应履行退款或赔付义务。如判定乙方应对消费者进行退款、支付违约金和/或赔偿款，甲方有权从乙方保证金（见下文定义）中直接划扣相应金额支付给消费者，然后向乙方追偿或从任何甲方应付乙方款项中扣除。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）乙方应指派专人负责处理消费者提交或甲方转交的客户服务问题（统称“工单”），并将服务电话（内部接口专用）及工作邮件（内部接口专用）提供至甲方。乙方应在【24】小时内回复客服问题，同时乙方官方渠道（包括但不限于平台账号、网站、微博、微信等）应当对客户提问在24小时内予以反馈回复。对于超时回复，甲方有权按照大V店平台规则扣除乙方保证金；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）乙方回复内容中应包含对于该问题的解释、明确处理方案及事件说明，不能出现“正在查询/正在沟通”等无实质解决方案的回复，否则即视为延迟回复，具体以甲方的认定为准；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）乙方客服负责人联系方式如下，如有变更乙方应及时通知甲方，否则所产生的一切损失由乙方承担；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方应就本协议项下甲方及甲方平台卖家向乙方提供的服务向甲方及甲方平台卖家支付服务费。商品类别及服务费标准见"), _c('b', [_vm._v("附件二《大V店平台商品类别及服务费标准》、附件三《大V店平台卖家商品类别及服务费标准》")]), _vm._v("。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("\n                    结算周期：甲乙双方同意就每30天期间交易完成订单的商品货款及服务费于期间届满后【5】日内进行对账工作。双方数据核对一致后，甲方就上述商品实际交易货款扣除甲方服务费、甲方平台卖家服务费及其他依据本协议、本协议附件及大V店平台规则应扣除费用后的款项余额与乙方结算。结算货币为人民币。\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("对于乙方自甲方获取的任何补贴收入，包括但不限于各类优惠券、代金券、现金抵用券补贴，乙方应根据甲方要求向甲方开具合法有效的发票。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议终止时（无论任何原因），甲方有权继续留存最后一期应付乙方款项【3】个月。若本协议履行期间及本协议终止后，甲方未因乙方不履行或不完全履行本协议遭受损失（包括但不限于商品违法、侵权、质量缺陷、商品宣传违规等），或乙方已按本协议约定向甲方支付各项费用及欠款，则甲乙双方可就最后一期应付乙方款项进行结算。否则，甲方有权直接从最后一笔结算款项中扣除对应款项，最后一笔结算款项不足以弥补甲方损失部分，或不足以支付各项费用及欠款，乙方应继续承担相应赔偿责任。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("保证金")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist10",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("乙方同意向甲方指定账户缴存一定金额（“保证金”）用于担保其对本协议的履行和遵守。乙方应当在签订本协议后【10】日内向甲方支付总计人民币【10000】元的保证金。 甲方有权根据乙方经营情况随时调整保证金额度。 如本协议为续签协议，甲乙双方同意，乙方根据双方签署的原《技术服务协议》及与其项下附件、补充协议（“原协议”）缴存的保证金余额继续适用于本协议。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("\n                   如乙方保证金额度调整或出现任何保证金被扣减情形，导致乙方保证金不足约定金额时，乙方同意甲方自应付乙方的任何款项中直接扣除差额，如甲方应付乙方款项不足弥补保证金差额，乙方应当于收到甲方通知之日起【10】日内将保证金补足。\n                ")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方保证金银行账户信息如下：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("户名：【天津果敢时代国际贸易有限公司】")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("开户行：【招商银行股份有限公司天津武清支行】")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-11pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("账号：【122907366910806】")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方可在以下情形发生时，处置保证金：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）如乙方违反国家法律法规、本协议、大V店平台规则或其他政策规定，应向消费者退还货款、支付违约金和/或赔偿款的，甲方有权直接划扣保证金用于代乙方向消费者退还货款、支付违约金和/或赔偿款；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）如乙方违反国家法律法规、本协议、大V店平台规则或其他政策规定，致使甲方及/或其关联公司权益受损（包括但不限于被行政处罚、被判决侵权、商誉受损等），甲方有权划扣保证金中的相应金额至甲方账户作为违约金和/或赔偿款；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）如乙方违反本协议或大V店平台规则，根据本协议或大V店平台规则应当向甲方支付惩罚金、违约金和/或赔偿款，甲方有权划扣保证金中的相应金额至甲方账户作为惩罚金、违约金和/或赔偿款；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）如乙方违反其与甲方或其关联公司的其他协议规定造成甲方或其关联公司损失或应支付违约金，乙方同意甲方可基于该协议规定直接划扣保证金中的相应金额；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（5）其他甲方有合法合理理由可处置保证金的情况。")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议履行期间，保证金的支配、使用权均归属于甲方。在乙方解散、清算、破产时，甲方享有对保证金的优先受偿权。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议终止时（无论任何原因），甲方有权继续留存保证金【3】个月。若本协议履行期间及本协议终止后，甲方未因乙方不履行或不完全履行本协议遭受损失（包括但不限于商品违法、侵权、质量缺陷、商品宣传违规等），或乙方已按本协议约定向甲方支付各项费用及欠款，则甲方将保证金余额无息退还乙方。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("知识产权")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist11",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("与商品相关的专利、商标、名称、特有标识、装潢、技术秘密等均属于其权利人所有。乙方保证其已按照法律规定或者合同约定获得了通过大V店平台销售商品或服务的权利或许可，该等权利或许可不与任何排他性权利相冲突，否则乙方应赔偿甲方因此而产生的任何经济损失。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("\n                   乙方在此不可撤销地免费授权甲方 (并许可甲方对该权利进行再授权)，以推广乙方商品为目的，全部或部分地摘录、改编、翻译、复制、发布、展示或以其它任何合理方式使用乙方提供给甲方或其在大V店平台展示的任何信息和资料（包括但不限于商品商标、logo、商品信息、宣传资料、订单信息等)。\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("乙方保证和承诺")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist12",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("除严格遵守本协议和大V店平台规则其它规定外，乙方保证和承诺：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）乙方具有签订和履行本协议所需的所有合法资格、资质和能力，包括应持有中国法律法规所要求的一切证明、批准、许可和其他任何证明文件，而且应为商品的生产商或授权经销商；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）乙方在大V店平台销售的商品来源正当合法，均为全新正品行货；乙方对其所销售商品享有唯一的合法的所有权，并且商品在本协议项下的推广和销售未侵犯任何第三方的权利，包括但不限于第三方的知识产权；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）乙方在大V店平台上销售的同款商品的销售价格不高于其提供给任何其他渠道或采购方的价格；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）乙方（第三方商家）自主决定是否就其所销售商品在甲方平台发布广告及广告的内容和形式，保证广告真实、合法，并承担因广告引起的全部法律责任；甲方仅对乙方上传的商品信息进行审核，不对广告进行审核，也不对广告承担法律责任；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（5）乙方在使用大V店平台服务的过程中遵守诚实信用原则，不在交易过程中采取虚假宣传等不正当竞争行为，不扰乱网上交易的正常秩序，不从事与网上交易无关的行为；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（6）乙方维护甲方及甲方平台的良好声誉和形象，不会作出任何有损甲方品牌形象和良好声誉的言论及行动，否则甲方有权拒绝履行本协议，并要求乙方采取补救措施。若发现乙方故意诋毁或损害甲方声誉的情形，甲方有权立即终止本协议，并追究乙方违约责任。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("甲方免责")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist13",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("不论在何种情况下，甲方均不对由于网络连接故障、计算机系统故障、通讯故障、电力故障、电脑病毒、黑客入侵、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、爆炸、战争等不可抗力事件而造成的不能服务或延迟服务承担责任。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("大V店平台仅作为乙方寻找交易对象，就商品和服务的交易进行协商以及获取各类与交易相关服务的平台。本协议的签署并不意味着甲方成为乙方在大V店平台上与第三方所进行交易的参与者。甲方仅对乙方于消费者的交易行为提供技术服务，不对乙方行为的合法性、有效性及商品的真实性、合法性和有效性作任何明示或暗示的担保。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("保密和知识产权")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist14",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("任何一方均应对本协议内容，以及依据本协议而获得的对方的保密或专有信息（包括但不限于，与对方的技术、客户、商业计划、营销活动和财务有关的所有信息）（ “"), _c('b', [_vm._v("保密信息")]), _vm._v("”）严格保密，并且不得用于本协议以外目的，否则应对因此给对方造成的损失承担赔偿责任。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("未经甲方及/或其关联公司同意，乙方不得使用甲方及/或其关联公司的任何商标、服务标识、品牌或其他知识产权，不得发布有关甲方及/或其关联公司或者本合同的任何新闻稿或其他公开文件，或在任何宣传资料中提及甲方及/或其他关联公司。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("不可抗力")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist15",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("由于不能预见、不能避免、不能克服的客观原因，包括但不限于地震、台风、海啸等自然灾害，政治动荡、暴动、战争、政府行为，以及通讯或其他设施故障等，导致一方无法履行本协议项下义务，不承担违约责任。前提是，该方已经及时以适当的方式向另一方告知该不可抗力事件的发生并提供相关证明材料。并且在不可抗力事件的影响消失后，应当立即恢复履行合同。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("任何一方可在另一方严重违反本协议（包括本协议附件、大V店平台规则等）且收到守约方书面通知后十五(15)个工作日内未予以纠正时，书面通知另一方，立即终止本协议；任何一方可以经提前六十天向另一方发出书面通知而无因终止协议，前提是乙方已经履行完毕其在本协议终止前已接受的订单。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("协议终止后续事项的处理")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）自本协议终止之日起，甲方将乙方商品和服务内容全部下架并进行清算，乙方不得再通过该账户进行任何形式的操作。如果乙方在商品下架后再次上架进行销售，且有消费者提交订单并进行支付，乙方应当按照本协议要求对相关商品进行配送，由此产生的货款，甲方有权不予结算；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）本协议终止后，甲方有权保留乙方的注册信息及交易行为记录等数据，但甲方没有为乙方保留这些数据的义务，亦不承担在协议终止后向乙方或第三方转发任何未阅读或未发送的信息的义务，也不就协议终止向乙方或任何第三方承担责任，但法律另有规定的除外；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）本协议终止并不免除乙方依据本协议应向客户承担的商品质量责任和售后服务义务；如本协议终止后，因乙方商品质量问题或售后服务问题而导致甲方或其他任何第三方人身或财产损失的，乙方仍应承担全部赔偿责任。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("违约责任")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist17",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议履行过程中，乙方如违反国家法律法规、本协议、大V店平台规则或其他政策任何规定，或侵犯任何第三方（包括但不限于消费者、知识产权权利人或商品/服务的实际使用者）合法权益，除根据本协议和/或大V店平台规则向甲方支付惩罚金、违约金外，还应赔偿甲方因此遭受的全部损失，包括但不限于：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（1）甲方被判决须向任何第三方支付的违约金或赔偿额；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（2）甲方被执行行政处罚的金额；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（3）甲方代乙方向消费者支付的退款、违约金或赔偿额；")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt 0pt 0pt 15pt",
      "text-indent": "-21pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("（4）甲方支付的合理律师费用、消除影响所支出的必要费用。")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("同时，乙方还应当按照甲方的要求，采取措施以停止侵害、恢复名誉、消除影响等。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议履行过程中，乙方保证乙方股东、实际控制人、董事、经理、业务负责人、雇员、代理人、受托人等（以下称“乙方代表”）均严格履行本协议规定，并遵守大V店平台所公示的各项准则，乙方代表违反本协议任何内容的行为视为乙方违约行为，乙方应对此承担全部法律责任。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "list-style-position": "inside",
      "margin": "10pt 0pt 0pt 31.5pt",
      "text-indent": "-28.35pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v("      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("其他")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ol', {
    staticClass: "awlist18",
    staticStyle: {
      "margin-left": "-17pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议受中华人民共和国法律管辖。对于因本协议而产生的任何争议，双方均应努力通过友好协商的方式进行解决。如无法就争议解决达成一致，任何一方均可向合同签订地人民法院提起诉讼。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议一方未经另一方事先书面同意不得将其本协议项下的权利和义务全部或部分转让给任何第三方。尽管有前述规定，乙方同意，甲方可将本协议（或其在本协议项下的任何权利或义务）转让给其关联公司，或当发生合并、重组、出售全部或重要资产或类似交易时转让给其后续公司。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议无论因任何原因终止，除协议中已有规定外，商品质量、售后服务、知识产权、保密、保证和承诺、违约责任条款在协议终止后将继续有效。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("除非本协议另有规定或双方另有约定，甲乙双方就本协议所作的通知及其他通信，均需通过书面形式送达。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议未尽事宜，甲乙双方另行签订书面补充协议。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("本协议内容包括协议正文、附件、补充协议（如有）以及甲方不时修订的大V店平台规则。任何对本协议或大V店平台规则的修订一经生效即构成协议各方权利义务的补充，并成为本协议的一部分。本协议经双方授权代表签署并加盖双方公章或合同章后生效。本协议一式贰（2）份，甲乙双方各执壹（1）份，具有同等效力。")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "normal",
      "list-style-position": "inside",
      "margin": "0pt 0pt 6pt 10.35pt",
      "text-indent": "-21.25pt",
      "padding-left": "7pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font": "7.0pt 'Times New Roman'"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲乙双方在本协议生效前签订的协议在本协议生效后即时终止。未完成事项可由双方参考本协议约定事项进行处理。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v("[以下无正文]")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-style": "italic"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("甲方（盖章）：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("天津果敢时代国际贸易有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "10.5pt",
      "line-height": "115%",
      "margin": "7.8pt 0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "center"
    }
  }, [_c('br', {
    staticStyle: {
      "page-break-before": "always",
      "clear": "both"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("附件一 乙方资质证明文件清单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "float": "left",
      "margin": "0pt 9pt",
      "width": "387.45pt"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("文件名称")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-indent": "68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("资质要求及涉及类别")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-indent": "68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("1.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-indent": "68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-indent": "68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("基本资质证件")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-indent": "68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("1.1")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("营业执照副本")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("必须具有独立法人资格；如为分支机构，不具有独立法人资格，需提供总公司授权书；")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("1.2")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("法定代表人身份证")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("有效期内，正反面复印；")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("1.3")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("税务登记证（三证合一后无需提供）")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("有效期内；")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("1.4")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("组织机构代码证（三证合一后无需提供）")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("有效期内；")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("1.5")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("一般纳税人认定证书")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("有效期内；")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("1.6")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("开户银行许可证")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("有效期内；")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("1.7")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("商标注册证")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("有效期内；")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("1.8")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("品牌授权销售代理协议或证明")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("如为品牌代理商，须提供生产商、品牌商或商标专有权人授权销售证明文件")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("1.9")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("进口货物报关单")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("海关出具的注有进口数量、成交总价的凭证")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-indent": "68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("2.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-indent": "68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-indent": "68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v("特许经营资质文件")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-indent": "68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("2.1")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("食品经营许可证、批次生产卫生检验报告或化验单、厂家卫生许可证")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("食品")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("2.2")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("食品经营许可证、批次生产卫生检验报告或化验单、厂家卫生许可证、保健食品批准证书以及保健食品生产企业批准证书、进口保健食品批准证书（如为进口保健食品）")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("保健食品")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("2.3")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("出版物经营许可证")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("出版物、音像制品、电子出版物")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("2.4")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("医疗器械经营许可证")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("第二类医疗器械")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("2.5")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("批次化妆品检验报告；特殊用途化妆品卫生批准文件（如为特殊用途化妆品）；生产厂家卫生许可证复印件以及生产厂家生产许可证复印件")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("国产化妆品")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "4.5pt"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("2.6")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "146.34pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "padding-bottom": "2pt",
      "orphans": "0",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("进口化妆品卫生许可批件；进口化妆品厂家检验报告；进口检验检疫部门检验报告以及标签审核证书")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "5.4pt",
      "padding-right": "5.4pt",
      "vertical-align": "top",
      "width": "219.51pt"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "padding": "0 0 2pt 68.25pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("进口化妆品")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0pt"
    }
  }, [_c('br', {
    staticStyle: {
      "page-break-before": "always",
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("附件二：《大V店平台商品类别及服务费标准》")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background-color": "#ffffff",
      "line-height": "15.75pt",
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#ffffff",
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "1pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "1pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "1pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "1pt",
      "padding-left": "4.9pt",
      "padding-right": "4.9pt",
      "vertical-align": "top",
      "width": "127.45pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("商品名称")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#ffffff",
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "1pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "1pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "1pt",
      "padding-left": "5.4pt",
      "padding-right": "4.9pt",
      "vertical-align": "top",
      "width": "83.15pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("品牌")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#ffffff",
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "1pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "1pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "1pt",
      "padding-left": "5.4pt",
      "padding-right": "4.9pt",
      "vertical-align": "top",
      "width": "171.8pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "华文楷体",
      "font-size": "9pt"
    }
  }, [_vm._v("固定比例（%/单）")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background-color": "#ffffff",
      "line-height": "15.75pt",
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background-color": "#ffffff",
      "line-height": "15.75pt",
      "margin": "0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt",
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("附件三：《大V店平台卖家商品类别及服务费标准》")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#ffffff",
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "1pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "1pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "1pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "1pt",
      "padding-left": "4.9pt",
      "padding-right": "4.9pt",
      "vertical-align": "top",
      "width": "127.45pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("商品名称")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#ffffff",
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "1pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "1pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "1pt",
      "padding-left": "5.4pt",
      "padding-right": "4.9pt",
      "vertical-align": "top",
      "width": "127.45pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("品牌")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#ffffff",
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "1pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "1pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "1pt",
      "padding-left": "5.4pt",
      "padding-right": "4.9pt",
      "vertical-align": "top",
      "width": "127.5pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "楷体",
      "font-size": "10.5pt"
    }
  }, [_vm._v("固定比例（%/单）")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "7.8pt 0pt 0pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman'",
      "font-size": "10.5pt"
    }
  }, [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74598d3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplier/contract/view/contract_4.vue
// module id = 551
// module chunks = 0